import { cn } from '~/lib/cn';

export const OVERLAY_CLASS = {
  show: cn('animate-[dialogOverlay_300ms_ease-out_forwards]'),
  hide: cn('animate-[dialogOverlay_300ms_ease-in_reverse_forwards]'),
} as const;

export const CONTENT_CLASS = {
  show: cn('animate-[dialogContent_300ms_ease-out_forwards]'),
  hide: cn('animate-[dialogContent_300ms_ease-in_reverse_forwards]'),
  disable: cn('!pointer-events-none'),
} as const;
